const uuidv4 = require('uuid/v4');
const jwt = require('jsonwebtoken');
const bcrypt = require('bcryptjs');

const VUE_APP_GEN_KL = 'eyJhbGciOiJIUzUxMiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkFEVFdFQiIsImV4cCI6MTYxMTQwODgyOCwiaWF0IjoxNjExNDA4ODI4fQ';

function genkeys(key1, key2){
    let saltRounds = bcrypt.genSaltSync(4);
    
    let b1s = bcrypt.hashSync(key1,saltRounds);
    
    let v2s = bcrypt.hashSync(key2,saltRounds);
    let genkl = bcrypt.hashSync(VUE_APP_GEN_KL,saltRounds);
   
    let uidgen = uuidv4();
    let a1 = bcrypt.hashSync(uuidv4());
    let v1 = bcrypt.hashSync(uuidv4());
    let c2s = jwt.sign({ uidgen }, genkl, {algorithm: "HS256",expiresIn: 20});
    let genkeys = {};
    genkeys.b1s=b1s;
    genkeys.v2s=v2s;
    genkeys.genkl=genkl;
    genkeys.uidgen=uidgen;
    genkeys.a1=a1;
    genkeys.v1=v1;
    genkeys.c2s=c2s;
    return genkeys;
}

module.exports = genkeys;
